const find = require('lodash/find');

const LocalizedOrderStore = function LocalizedOrderStoreConstructor() {
  this.store = [];
};

LocalizedOrderStore.prototype.addOrder = function addOrder(localizedOrder) {
  if (!localizedOrder) {
    throw new Error('localizedOrder must be defined');
  }

  const existing = this.getById(localizedOrder.id);

  if (!existing) {
    this.store.push(localizedOrder);
  }
};

LocalizedOrderStore.prototype.getById = function getById(orderId) {
  if (!orderId) {
    return undefined;
  }

  return find(this.store, order => order.id.toString() === orderId.toString());
};

LocalizedOrderStore.prototype.clear = function clear() {
  this.store = [];
};

module.exports = LocalizedOrderStore;



// WEBPACK FOOTER //
// ./static/js/v0/cache/localized-order-store.js